<template>
  <div class="custom-modal">
    <div class="modal-body">
      <div class="information-form" >
        <div class="information-form-input">
          <label>{{$t('deleteMyAccount')}}</label>
          <el-select v-model="reason"  :placeholder="$t('choose')">
            <el-option v-for="item in deleteReasons" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
          <span>{{ $errorMessage("reason", validationErrors) }}</span>
        </div>
           <div class="information-form-input" v-if="reason == '63297efadc1d7ab355d57691'">
          <label>{{$t('reason')}}</label>
          <el-input type="textarea" :rows="2" placeholder="..." v-model="reasonText"></el-input>
          <span>{{ $errorMessage("reason", validationErrors) }}</span>
        </div>
      </div>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="danger" :loading="loading == 'deleteAccount'" @click="deleteAccount">{{ $t('delete') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
export default {
  name: "DeleteAccount",
  data() {
    return {
      reasonList: ['Etkinlik Sona Erdi', 'Uygulamayı Kullanışlı Bulmuyorum', 'Diğer'],
      moment,
      reason:null,
      loading: false,
      timeout: null,
      validationErrors: [],
      reasonText:null,
    };
  },
  computed: {
    deleteReasons(){
      return this.$store.getters.getAccountDeleteReasons;
    },
    getEnums(){
      return this.$store.getters.getEnums;
    },
  },
  methods: {
    deleteMe() {
      this.$emit("closeDialog");
      this.$emit("deleteMe", this.form.id);
    },
    async deleteAccount() {
      this.loading = "deleteAccount";
      if (this.timeout != null) clearTimeout(this.timeout);
      var dummyReason = this.reason;
      if(dummyReason == '63297efadc1d7ab355d57691'){
        dummyReason = this.reasonText;
      }
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteMyAccount", 
         {reason:dummyReason}
        );
        this.validationErrors = res.data.validationErrors;
        if (!res.data.hasError) {
          await this.$store.dispatch("getUser");
        }
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/account/DeleteAccount.vue